import React, { ReactNode } from 'react';

import userFormSchema, { UserFormSchema } from 'core/schemas/userForm';
import { Form, FormSubmitHandler } from 'Elements/Form';

type Props = {
  onSubmit: FormSubmitHandler<UserFormSchema>;
  user?: Partial<UserFormSchema['user']>;
  children: ReactNode;
};

export default function UserForm({ onSubmit, user, children }: Props) {
  return (
    <Form
      validationSchema={userFormSchema.meta({ user })}
      onSubmit={onSubmit}
      initialValues={{ user }}
    >
      {children}
    </Form>
  );
}
